<script setup lang="ts">
  import { inject, useSlots } from 'vue';
  import { descriptionContextKey } from './descriptions';

  defineOptions({
    name: 'IDescriptionItem',
  });

  defineProps({
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    // 合并列数
    span: {
      type: Number,
      default: 1,
    },
    // 合并行数
    rowSpan: {
      type: Number,
      default: 1,
    },
  });
  const descProps = inject(descriptionContextKey);
  const slots = useSlots();
</script>

<template>
  <div
    :class="`i-descriptions-item__${descProps?.size || 'default'}`"
    class="i-descriptions-item"
    :style="{
      gridColumnStart: `span ${span}`,
      gridRowStart: `span ${rowSpan}`,
    }"
  >
    <div class="i-descriptions-label" :title="label" :style="{ width: descProps?.labelWidth || '100px' }">
      <slot v-if="slots.label" name="label" />
      <template v-else>
        <i v-if="icon" class="iconfont" :class="icon" />
        <div class="i-descriptions-label__text">{{ label }}</div>
      </template>
    </div>
    <div class="i-descriptions-value">
      <slot name="default" />
    </div>
  </div>
</template>
